<template>
    <b-card class="m-4">
        <template #header>
            <div class="text-right">
                <b-button :to="{ name: 'MembershipNew' }" variant="primary"><font-awesome-icon icon="plus"></font-awesome-icon> Nueva</b-button>
            </div>
        </template>

        <b-row class="mb-2">
            <b-col sm="5" md="6" class="my-1">
                <b-input-group size="sm" prepend="Mostrando" append="registros">
                    <b-form-select v-model="itemsPerPage" id="perPageSelect" size="sm" :options="pageOptions" style="max-width: 5em"></b-form-select>
                </b-input-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-input-group prepend="Filtrar: ">
                    <b-input v-model="filter" debounce="300"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
        <!--<b-row class="mb-2">-->
            <!--<b-col sm="5" md="6" class="my-1 text-left">-->
                <!--<b-form-group label="Filtrar por fecha de publicación">-->
                    <!--<date-range-picker opens="right" :locale-data="localeData" :append-to-body="true" :showWeekNumbers="false"-->
                                       <!--v-model="dates" :autoApply="true" :linkedCalendars="true" :date-range="dates" :ranges="false"-->
                                       <!--style="width: 250px" @update="updateDates">-->
                        <!--<template v-slot:input style="min-width: 200px;">-->
                            <!--<span v-if="startDate !== ''">{{ startDate }} - {{ endDate }}</span>-->
                            <!--<span v-else>Fecha inicio - Fecha fin</span>-->
                        <!--</template>-->
                    <!--</date-range-picker>-->
                    <!--<b-button variant="success" class="ml-2" @click="clearDatesInput">-->
                        <!--<font-awesome-icon icon="eraser"></font-awesome-icon> Limpiar-->
                    <!--</b-button>-->
                <!--</b-form-group>-->
            <!--</b-col>-->
        <!--</b-row>-->
        <b-table :items="loadData" :fields="fields" :filter="filter" :current-page="currentPage" :per-page="itemsPerPage"
                 empty-text="Sin registros" empty-filtered-text="Sin coincidencias" :sort-by.sync="sortBy"
                 striped bordered hover small show-empty responsive ref="membershipsTable">
            <!--<template #thead-top>-->
            <!--<b-tr>-->
            <!--<b-th v-for="(field, index) in fields" :key="field.key">-->
            <!--<b-row>-->
            <!--<b-col v-if="filters[index]">-->
            <!--<b-input :placeholder="field.label" v-model="filters[index].value" debounce="300"></b-input>-->
            <!--</b-col>-->
            <!--</b-row>-->
            <!--</b-th>-->
            <!--</b-tr>-->
            <!--</template>-->

            <!--                    <template v-slot:cell(status)="row">-->
            <!--                        <div class="text-center">-->
            <!--                            <b-badge variant="info" v-if="row.item.status === 'DRAFT'" class="p-1">Borrador</b-badge>-->
            <!--                            <b-badge variant="success" v-else>Publicado</b-badge>-->
            <!--                        </div>-->
            <!--                    </template>-->

            <template v-slot:cell(level)="row">
                <b-badge :variant="levelBadgeVariant(row.item.level)">{{ MEMBERSHIP_LEVELS[row.item.level] }}</b-badge>
            </template>

            <template v-slot:cell(storageUse)="row">
                <div style="min-width: 120px">
                    <b-progress class="mt-2" :max="row.item.storageLimit" height="1.5rem">
                        <b-progress-bar :value="row.item.storageUsage" :variant="progressbarVariant(row.item)"></b-progress-bar>
                    </b-progress>
                    <small class="text-dark d-flex text-center" style="margin-top: -24px; line-height: 24px">{{ storageUsedLabel(row.item) }}</small>
                </div>
            </template>

            <template v-slot:cell(userLimits)="row">
                <div><strong>BackOffice:</strong> {{ row.item.userLimit }}</div>
                <div><strong>Portal:</strong> {{ row.item.portalUserLimit }}</div>
            </template>

            <template v-slot:cell(status)="row">
                <b-badge v-if="row.item.enable" variant="primary">Activo</b-badge>
                <b-badge v-else variant="warning">Inactivo</b-badge>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button-group size="sm">
                    <b-button :to="{ name: 'MembershipEdit', params: { id: row.item.id }}" v-b-tooltip.hover
                              title="Modificar" variant="outline-primary">
                        <font-awesome-icon icon="edit"></font-awesome-icon>
                    </b-button>
                    <b-button  v-b-tooltip.hover :title="row.item.enable ? 'Desactivar' : 'Activar'" variant="outline-primary"
                               @click="changeStatus(row.item)">
                        <font-awesome-icon :icon="row.item.enable ? 'toggle-off' : 'toggle-on'"></font-awesome-icon>
                    </b-button>
                </b-button-group>
            </template>

            <template v-slot:table-caption>
                <b-row class="no-gutters">
                    <b-col sm="5" md="6">
                        Total de registros: {{ totalRows }}
                    </b-col>
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-table>

<!--        <b-row>-->
<!--            <b-col offset-sm="5" offset-md="6" sm="7" md="6" class="my-1">-->
<!--                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>-->
<!--            </b-col>-->
<!--        </b-row>-->
    </b-card>
</template>

<script>
import { membershipListUrl, membershipEnableUrl } from '@routes';
import * as constants from '@constants';
//import DateRangePicker from 'vue2-daterange-picker'

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    props: {
        settings: Object
    },
    data() {
        return {
            fields: [
                { key: 'id', label: 'ID'/*, sortable: true*/ },
                { key: 'name', label: 'Nombre'/*, sortable: true*/ },
                { key: 'taxId', label: 'RFC'/*, sortable: true*/ },
                { key: 'memberName', label: 'Membresía'/*, sortable: true*/ },
                { key: 'level', label: 'Plan'/*, sortable: true*/ },
                { key: 'storageUse', label: 'Espacio utilizado'/*, sortable: true*/ },
                { key: 'userLimits', label: 'Límite de usuarios'/*, sortable: true*/ },
                { key: 'email', label: 'Correo'/*, sortable: false*/ },
                { key: 'phone', label: 'Teléfono'/*, sortable: false*/ },
                { key: 'created', label: 'Fecha de creación'/*, sortable: false*/ },
                { key: 'purchaseDate', label: 'Fecha de compra'/*, sortable: false*/ },
                { key: 'expirationDate', label: 'Fecha de expiración'/*, sortable: false*/ },
                { key: 'status', label: 'Estatus', class: 'text-center' },
                { key: 'actions', label: 'Acciones', class: 'text-center' }
            ],
            filters: [
                { column: 'm.id', type: 'STRING', value: '', format: '' },
                { column: 'm.name', type: 'STRING', value: '', format: '' },
                { column: 'm.tax_id', type: 'STRING', value: '', format: '' },
                { column: 'm.member_name', type: 'STRING', value: '', format: '' },
                { column: 'm.level', type: 'STRING', value: '', format: '' },
                { column: 'm.storage_usage', type: 'STRING', value: '', format: '' },
                { column: 'm.portal_user_limit', type: 'STRING', value: '', format: '' },
                { column: 'm.email', type: 'STRING', value: '', format: '' },
                { column: 'm.phone', type: 'STRING', value: '', format: '' },
                { column: 'm.created', type: 'STRING', value: '', format: '' },
                { column: 'm.purchase_date', type: 'STRING', value: '', format: '' },
                { column: 'm.expiration_date', type: 'STRING', value: '', format: '' }
            ],
            filter: '',
            isLoading: false,
            pageOptions: [25, 50, 75, 100],
            totalRows: 0,
            currentPage: 1,
            itemsPerPage: 25,
            sortBy: 'm.id',
            sortDesc: false,
            localeData: {
                direction: 'ltr',
                format: 'yyyy-mm-dd',
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                weekLabel: 'S',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['D', 'L', 'M', 'Mi', 'J', 'V', 'S'],
                monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                firstDay: 0
            },
            dates: {
                startDate: '',
                endDate: ''
            }
        }
    },
    /*components: {
        DateRangePicker
    },*/
    methods: {
        loadData(ctx) {
            if (ctx.sortBy !== '') {
                let data = {
                    filters: this.filters.filter(filter => filter.value.trim() !== ''),
                    ...ctx
                };

                data.currentPage = (data.currentPage - 1) * data.perPage;
                data.dates = {
                    startDate: this.startDate,
                    endDate: this.endDate
                };

                return this.axios.post(membershipListUrl(), data).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.totalRows = response.data.totalRows;
                        return response.data.memberships;
                    } else {
                        return [];
                    }
                }).catch(error => {
                    console.error(error);
                });
            }
        },
        changeStatus(membership) {
            this.$swal({
                title: `¿${membership.enable ? 'Desactivar' : 'Activar'} la membresía de ${membership.name}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.axios.put(membershipEnableUrl(), {
                        membershipId: membership.id,
                        enabled: !membership.enable
                    }).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            membership.enable = !membership.enable;

                            this.$bvToast.toast(response.data.message, {
                                title: 'Membressías',
                                variant: 'success'
                            });
                        }
                    }).catch(() => {
                        this.$bvToast.toast('Ocurrió un error al guardar la configuración.', {
                            title: 'Clientes',
                            variant: 'danger'
                        });
                    });
                }
            });
        },
        storageUsedLabel(membership, forceGB = false, hidePercentage = false) {
            const ratio = 1024, digits = 2;
            let storageUsed = membership.storageUsage;
            let storageLimit = membership.storageLimit;
            let unit = 0;
            let units = ['B', 'KB', 'MB', 'GB'];
            let percentage = '';

            if (forceGB) {
                for (let i = 0; i < 3; i++) {
                    storageLimit /= ratio;
                    unit++;
                }
            } else {
                while (storageLimit > 1024) {
                    storageLimit /= ratio;
                    unit++;
                }
            }

            for (let i = 0; i < unit; i++) {
                storageUsed /= ratio;
            }

            if (!hidePercentage) {
                percentage = `(${((storageUsed / storageLimit) * 100).toFixed(digits)}%)`;
            }

            return `${storageUsed.toFixed(digits)} / ${storageLimit.toFixed(digits)} ${units[unit]} ${percentage}`;
        },
        progressbarVariant(membership) {
            const usage = membership.storageUsage, limit = membership.storageLimit;
            const OK_LIMIT = 0.5;
            const WARN_LIMIT = 0.9;

            return (usage / limit < OK_LIMIT) ? 'success' : (usage / limit < WARN_LIMIT) ? 'warning' : 'danger';
        },
        levelBadgeVariant(level) {
            let variant = '';

            if (level === constants.MEMBERSHIP_LEVELS.B) {
                variant = 'info';
            } else if (level === constants.MEMBERSHIP_LEVELS.C) {
                variant = 'success'
            }

            return variant;
        }
        /*clearDatesInput() {
            this.dates.startDate = '';
            this.dates.endDate = '';

            this.$refs.membershipsTable.refresh();
        },
        updateDates() {
            this.$refs.membershipsTable.refresh();
        }*/
    },
    watch: {
        filters: {
            handler() {
                this.$refs.membershipsTable.refresh();
            },
            deep: true
        }
    },
    computed: {
        startDate() {
            let date = '';

            if (this.dates.startDate !== '') {
                date = `${this.dates.startDate.getFullYear()}-${(this.dates.startDate.getMonth() +1).toString().padStart(2, '0')}` +
                    `-${(this.dates.startDate.getDate()).toString().padStart(2, '0')}`
            }

            return date;
        },
        endDate() {
            let date = '';

            if (this.dates.endDate !== '') {
                date = `${this.dates.endDate.getFullYear()}-${(this.dates.endDate.getMonth() + 1).toString().padStart(2, '0')}` +
                    `-${(this.dates.endDate.getDate()).toString().padStart(2, '0')}`
            }

            return date;
        },
        MEMBERSHIP_LEVELS() {
            return constants.MEMBERSHIP_LEVELS;
        }
    }
}
</script>

<style>

</style>